import { Effect } from 'effector'
import { createEvent, sample } from 'effector/compat'

export const writeError = createEvent()

sample({
    clock: writeError,
    fn: (error) => {
        console.error(error)
    }
})

export function subscribeLoggerEffect(effect: Effect<any, any, any>) {
    effect.fail.watch((payload) => {
        if (!payload || !payload.error) return
        console.error(payload.error, payload?.params || '')
    })
}
